function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M255.1 155.9V99.2h-28.3V42.5H56.7v56.7H28.3v56.7H0v85h283.5v-85h-28.4zm-28.3-28.3v28.3h-56.7v-28.3h56.7zM85 70.9h113.4v28.3H85V70.9zm-28.3 56.7h85v28.3h-85v-28.3zm-28.4 56.7H85v28.3H28.3v-28.3zm226.8 28.3H113.4v-28.3h141.7v28.3z",
  id: "Peat"
})));